import { Component, Inject, Injectable, Optional } from "@angular/core";
import { DwActionHandler, DwButtonConfig, DwModalService, DwMenuService, DwMetaDataGridActionState, DwActionResult, DwAction, DwActionType, DwModalConfig, DwImportMetaDataModalComponent, DwModalButtonStandardConfigs, DwGridActionResult, DwRoutingService, DwModalSize, ensureArray, DwMetaDataFormStateService, DwMetaDataFormApi, DwEventService, DwGridEvents, DwActionItemRequirement, DwMdFormActionHandler, DwMdFormActionState, DwDecoratorType, DwActionButtonComponent, DwActionPreference, DwUiConfigContextBase, DwMediaModalService, DwMediaSelectOptions, DwMediaEntity, DwOrmDataServiceToken, DwOrmDataService, DwMessage, DwMessageSeverity, getErrorDetails } from "@devwareapps/devware-cap";
import { Observable, of } from "rxjs";
import { AcsWrittenResultEntity, AcsWrittenTestStatusAllItems, AppMetaData, AppMetaDataItemNames, AssignmentStudentEntity, CourseEntity, StudentCourseEntity, StudentCourseForContextQueryEntity } from "../../../meta-data/app-meta-data.service";
import { map } from "rxjs/operators";
import { CourseProgressVariableContext } from "../../courses/models/course-progress-variable-context.model";
import { AppPermissions } from "../../../meta-data/app-permissions.enum";
import { SchoolRepositoryService } from "../../schools/services/school-repository.service";
import { CourseRepositoryService } from "../../courses/services/course-repository.service";
import { StudentCourseEndorsementContext } from "../../courses/contexts/student-course-endorsement-context.service";
import { StudentRepositoryService } from "../services/student-repository.service";

@DwAction({
    keyName: 'course-submit-acs-written',
    display: 'Course - Submit ACS Written',
    actionType: DwActionType.formAction,
    parentItemName: AppMetaDataItemNames.Course,
    decoratorType: DwDecoratorType.component,
    isGlobal: false,
    actionMessage: 'Processing...',
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Submit ACS Written',
        iconClass: 'fa fa-code',
        buttonClass: 'btn btn-warning',
        buttonTitle: 'Upload a PDF or image of your ACS Written Exam'
    },
}) 
@Component({
    selector: 'dw-course-submit-acs-written-action',
    template: `
         <ng-container *ngIf="showSection">

            <dw-button *ngIf="!processing && !acsWrittenResult" [buttonConfig]="buttonConfig" [disabled]="uploading" [firing]="uploading" (click)="fileSingle.click()"><i class="fa fa-upload dw-icon-grid dw-green"></i> Upload ACS Written</dw-button>
            <span *ngIf="processing"><i class="fa fa-spinner fa-pulse fa-fw"></i> Processing...</span>
            <input type="file" #fileSingle placeholder="Choose file" (change)="selectFiles(fileSingle.files, fileSingle)" [accept]="allowedFileTypes" style="display:none;">

            <dw-message [(message)]="failureMessage"></dw-message>
        </ng-container>
    `,
})
export class CourseSubmitAcsWrittenActionService implements DwActionButtonComponent {
    allowedFileTypes: string = '.pdf,.jpg,.jpeg,.png';
    actionPreference: DwActionPreference<any, any>;
    actionContext?: DwUiConfigContextBase;
    buttonConfig: DwButtonConfig = {
        buttonText: 'Submit ACS Written',
        buttonClass: 'btn btn-primary',
        iconClass: 'fa fa-upload dw-icon-grid dw-green',
    }

    uploading: boolean = false;
    processing: boolean = false;
    acsWrittenResult: AcsWrittenResultEntity;

    showSection = true;

    showFailureMessage: boolean = false;
    failureMessage: DwMessage;
    formApi: DwMetaDataFormApi;
    studentCourseContext: StudentCourseForContextQueryEntity;

    constructor(
        private dwModalService: DwModalService,
        private dwMediaModalService: DwMediaModalService,
        private dwMenuService: DwMenuService,
        private dwRoutingService: DwRoutingService,
        @Optional() private dwFormStateService: DwMetaDataFormStateService,
        private courseRespositoryService: CourseRepositoryService,
        private dwEventService: DwEventService,
        @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
        private studentRepositoryService: StudentRepositoryService,
    ) {
        this.formApi = this.dwFormStateService?.state?.formApi;
    }

    setupComponent() {
        this.studentCourseContext = this.getStudentCourseContext();

        this.setupEventHandlers();

        this.setupRules();
    }

    
  setupEventHandlers(): void {
    this.formApi.getContextData(StudentCourseEndorsementContext)
        .subscribe(contextData => {
            this.studentCourseContext = contextData;
    
            this.setupRules();
        });
  }

    selectFiles(files: FileList, fileControl: any = null) {
        this.uploading = true;
        const mediaSelectOptions: DwMediaSelectOptions = {
            allowedFileTypes: this.allowedFileTypes,
            uploadInstructions: 'Upload a PDF or image of your ACS Written Exam',
            isSecure: false,
            imageResizeOptions: null,
            parentItemName: AppMetaDataItemNames.AcsWrittenResult,
            parentAttributeName: AppMetaData.AcsWrittenResult.Attributes.TestResultMediaId.fieldName
        };

        this.failureMessage = null;

        this.dwMediaModalService.showSelectFileModal(mediaSelectOptions, files).subscribe((result) => {
            if (result) {
                this.handleFileSelectResult(result);
            }

            this.uploading = false;
        })
    }

    getStudentCourseContext(): StudentCourseForContextQueryEntity {
        if (!this.dwFormStateService) {
            return null;
        }

        return this.formApi.getContextDataValue<StudentCourseForContextQueryEntity>(StudentCourseEndorsementContext);
    }

    // updateStudentCourseContext(acsWrittenResult: AcsWrittenResultEntity) {


    //     const context = this.getStudentCourseContext();

    //     context.RoStudentCourseAcsTestResultDetailACSTestResultCount++;

    //     context.CourseEndorsementStudentHasPassedACSWritten = context.CourseEndorsementStudentHasPassedACSWritten || (acsWrittenResult.Passed === true);
    //     context.CourseEndorsementStudentHasFailedACSWritten = context.CourseEndorsementStudentHasFailedACSWritten || (acsWrittenResult.Passed === false);

    //     this.formApi.patchContextData(StudentCourseEndorsementContext, context);
    // }

    updateStudentCourseContext() {
        const studentCourseContext = this.getStudentCourseContext();
        this.studentRepositoryService.getStudentCourseForContext(studentCourseContext.StudentCourseId)
            .subscribe(context => {
                this.studentCourseContext = context;

                this.setupRules();

                this.formApi.patchContextData(StudentCourseEndorsementContext, context);
            });
    }

    setupRules() {
        if (!this.studentCourseContext) {
            return;
        }

        if (this.studentCourseContext.RoStudentCourseAcsTestResultDetailPassedAny) {
            this.showSection = false;
        } else {
            this.showSection = true;
        }
    }


    handleFileSelectResult(result: DwMediaEntity) {
        const acsWrittenResult = AppMetaData.AcsWrittenResult.CreateEntity();
        acsWrittenResult.TestResultMediaId = result.MediaId;

        const studentCourseContext = this.getStudentCourseContext();
        acsWrittenResult.StudentCourseId = studentCourseContext?.StudentCourseId;
        acsWrittenResult.AcsTestId = studentCourseContext?.CourseAcsTestId;
        acsWrittenResult.AcsWrittenTestStatusId = AcsWrittenTestStatusAllItems.Processing;

        this.processing = true;

        this.dataService.saveEntity(acsWrittenResult, true)
            .subscribe(acsWrittenResult => {


                this.processing = false;
                this.acsWrittenResult = acsWrittenResult;

                if (this.acsWrittenResult.AcsWrittenTestStatusId == AcsWrittenTestStatusAllItems.FailedInvalid) {
                    this.failureMessage = {
                        messageHeading: 'ACS Written Submission Failed',
                        messageBody: 'Your ACS Written submission failed to process. Please ensure you have uploaded a valid PDF or image file.',
                        severity: DwMessageSeverity.error,
                        allowClose: true,
                    }
                } else {
                    this.updateStudentCourseContext();    
                }
            },
                error => {
                    this.processing = false;

                    const errorDetails = getErrorDetails(error);

                    this.failureMessage = {
                        messageHeading: 'ACS Written Submission Error',
                        messageBody: errorDetails?.message || 'An error occurred while processing your ACS Written submission. Please ensure you have uploaded a valid PDF or image file.',
                        severity: DwMessageSeverity.error,
                        allowClose: true,
                    };
                }
            )

    }

}